var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.089,
    height: 62.089,
    viewBox: "0 0 62.089 62.089",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "music-note",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M25.381,12.914a37.067,37.067,0,0,1-9.038-8.957L14.247.812a1.819,1.819,0,0,0-3.332,1.009v28.54a7.192,7.192,0,0,0-3.638-1.012,7.276,7.276,0,1,0,7.276,7.276V7.794a44.836,44.836,0,0,0,8.678,8.055,5.457,5.457,0,0,1-3.221,9.863,1.819,1.819,0,0,0,0,3.638,9.1,9.1,0,0,0,5.372-16.435Z",
    transform: "translate(0 -0.003)",
    fill: "#3e3e3e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191",
    transform: "translate(21.828 14.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M217.943,122.061l-25.709,7.276a1.821,1.821,0,0,0-1.32,1.75v24.659a7.192,7.192,0,0,0-3.638-1.012,7.276,7.276,0,1,0,7.276,7.276V139.736l22.071-6.237V148.47a7.192,7.192,0,0,0-3.638-1.012,7.276,7.276,0,1,0,7.276,7.276V123.811A1.821,1.821,0,0,0,217.943,122.061Z",
    transform: "translate(-180 -121.991)",
    fill: "#3e3e3e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.fedca98bcda2ffc234fa4d7a4e4d0df1.svg";
export { ForwardRef as ReactComponent };